import React, { useState } from "react";
import { Box, Button, FormControlLabel, Modal, Radio, RadioGroup, TextField } from "@mui/material";
import { X } from "lucide-react";
import axios from "axios";

const OLD_UI_URL = "https://v1.twilanswer.com";

export default function SwitchToOldUIModal({ open, onClose }) {
  const [experiencedBug, setExperiencedBug] = useState("");
  const [feedback, setFeedback] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const canSubmit = experiencedBug !== "" && feedback.trim().length > 0;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setSubmitting(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const email = user?.email?.S ?? user?.email ?? "";
      await axios.post(process.env.REACT_APP_BACKEND_URL + "feedback", {
        title: "Classic UI Switcher",
        email,
        "experienced bug": experiencedBug === "yes" ? "True" : "False",
        message: feedback.trim(),
      });
    } catch (err) {
      // Still redirect even if feedback fails
    }
    window.location.href = OLD_UI_URL;
  };

  const handleClose = () => {
    if (!submitting) {
      setExperiencedBug("");
      setFeedback("");
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
          maxWidth: 400,
          bgcolor: "#fff",
          borderRadius: "8px",
          boxShadow: 24,
          p: 3,
        }}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[16px] font-semibold text-gray-800">
            Use Classic View
          </h3>
          <X
            className="w-4 h-4 text-gray-400 cursor-pointer"
            onClick={handleClose}
          />
        </div>

        <p className="text-[13px] text-gray-600 mb-4">
          Please tell us why you’d like to use the classic view. Your feedback helps us improve.
        </p>

        <div className="mb-4">
          <label className="block text-[13px] font-medium text-gray-700 mb-2">
            Did you experience a bug?
          </label>
          <RadioGroup
            row
            value={experiencedBug}
            onChange={(e) => setExperiencedBug(e.target.value)}
          >
            <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
            <FormControlLabel value="no" control={<Radio size="small" />} label="No" />
          </RadioGroup>
        </div>

        <div className="mb-4">
          <label className="block text-[13px] font-medium text-gray-700 mb-2">
            Your feedback (required)
          </label>
          <TextField
            multiline
            minRows={3}
            placeholder="What would you like us to know?"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            fullWidth
            required
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "14px",
                borderRadius: "6px",
              },
            }}
          />
        </div>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!canSubmit || submitting}
          sx={{
            borderRadius: "6px",
            py: "8px",
            fontSize: "14px",
            "&.Mui-disabled": { bgcolor: "#E5E7EB", color: "#9CA3AF" },
          }}
        >
          {submitting ? "Redirecting…" : "Go to classic view"}
        </Button>
      </Box>
    </Modal>
  );
}
